import clsx from 'clsx';

import { InventoryPortalView } from '@atom/types/inventory';

import classes from './inventoryPortal.module.css';

export interface Props {
  activeView: InventoryPortalView;
  setActiveView: (activeView: InventoryPortalView) => void;
}

const InventoryPortalSubNav = ({ activeView, setActiveView }: Props) => {
  return (
    <div className={classes.subnavContainer}>
      <div className={classes.subnavControlsContainer}>
        {Object.keys(InventoryPortalView).map((view, key) => (
          <div
            key={key}
            onClick={() => setActiveView(InventoryPortalView[view])}
            className={clsx(
              classes.subnavControl,
              activeView === view && classes.active,
            )}
          >
            {view}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InventoryPortalSubNav;
